<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <vx-card class="grid-view-item mb-base overflow-hidden mb-5" no-body>
    <div slot="no-body" style="max-height: 240px" class="overflow-hidden">
      <img class="responsive cursor-pointer card-img-top"
           :src="classRoomPictureCompute"
           alt="content-img"
           @click="navigateToEditCourse">
    </div>

    <div class="flex justify-between flex-wrap center" >
      <h5 class="mb-2 cursor-pointer hover:text-primary" @click="navigateToEditCourse">
        {{ item.subject.code }}
      </h5>

      <vs-chip color="primary" transparent>
        {{ item.studentRegisterQty}}/{{ item.capacity }}
      </vs-chip>
    </div>

    <p class="text-grey">{{ item.subject.nameLocal }}</p>

    <div class="flex justify-between flex-wrap mt-2">
      <span class="flex items-center">
        {{ $t('student-enroll.section-no') }} {{ item.sectionNo }}
      </span>

      <span class="flex items-center mr-2">
        {{ $t('student-enroll.learn-span-no') }} {{ getClassSection(item) }}
      </span>
    </div>

    <vs-divider/>

    <div class="flex justify-center flex-wrap center mt-2">
      <div class="flex flex-wrap center">

<!--        <span class="flex mr-3 cursor-pointer items-center" @click="navigateToClassStats">
          <feather-icon icon="BarChartIcon" svgClasses="text-primary stroke-current hover:text-primary h-6 w-6"/>
          <span class="ml-2 hover:text-primary">{{ $t('teacher-dash-board.stats') }}</span>
        </span>-->

<!--        <span class="flex mr-3 cursor-pointer items-center" @click="navigateToAdvisor">
          <feather-icon icon="MessageSquareIcon" svgClasses="text-primary stroke-current hover:text-primary h-6 w-6"/>
          <span class="ml-2 hover:text-primary">{{ $t('sections.advisor.nav') }}</span>
        </span>-->

        <span class="flex mr-3 cursor-pointer items-center" @click="navigateToHomeWork">
          <feather-icon icon="BookIcon" svgClasses="text-success stroke-current hover:text-primary h-6 w-6"/>
          <span class="ml-2 hover:text-primary">{{ $t('teacher-dash-board.home-work') }}</span>
        </span>

        <span class="flex mr-3 cursor-pointer items-center" @click="navigateToSubmitScore">
          <feather-icon icon="UploadIcon" svgClasses="text-warning stroke-current h-6 w-6"/>
          <span class="ml-2 hover:text-primary">{{ $t('teacher-dash-board.submit-score') }}</span>
        </span>

        <span class="flex mr-3 cursor-pointer items-center" @click="navigateToStudentStat">
          <feather-icon icon="UsersIcon" svgClasses="text-danger stroke-current h-6 w-6"/>
          <span class="ml-2 hover:text-primary">{{ $t('teacher-dash-board.student-stat') }}</span>
        </span>

        <other-menu-drop-down :item="item"></other-menu-drop-down>
      </div>
    </div>

    <!--SLOT: ACTION BUTTONS -->
    <slot name="action-buttons"/>

  </vx-card>

</template>

<script>
import {config, getClassRoomUrl} from "@/utils/upload";
  import OtherMenuDropDown from "./DropDownMenu/OtherMenuDropDown";

  export default {
    props: [
      'item',
      'index',
    ],
    components:{
      OtherMenuDropDown
    },
    data(){
      return {
        classRoomPicture: this.getClassRoomPicture(this.item),
        baseUrl: config.baseUrl,
      }
    },
    computed: {
      classRoomPictureCompute(){
        return this.classRoomPicture;
      }
    },
    methods: {
      //---------------------------------------- Event Function ------------------------------------------------------//
      navigateToEditCourse() {
        this.$router.push({
          name: 'class-over-view',
          params: {
            classRoomId: this.item.id
          }
        })
        .catch(() => {
        })
      },
      navigateToHomeWork() {
        this.$router.push({
          name: 'student-assignment',
          params: {
            classSectionId: this.item.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToClassStats() {
        this.$router.push({
          name: 'classroom-stats',
          params: {
            classroomId: this.item.id
          }
        })
          .catch(() => {
          })
      },
      navigateToAdvisor() {
        this.$router.push({
          path: 'advisor',
          params: {
            classroomId: this.item.id
          }
        })
          .catch(() => {
          })
      },
      navigateToSubmitScore() {
        this.$router.push({
          name: 'student-score',
          params: {
            classSectionId: this.item.classSection.id
          }
        })
          .catch(() => {
          })
      },
      navigateToStudentStat() {
        this.$router.push({
          name: 'student-stats',
          params: {
            classSectionId: this.item.classSection.id
          }
        })
          .catch(() => {
          })
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      getClassRoomPicture(item){
        if(item.courseOutlineRegistration.courseOutline.picturePath){
          return getClassRoomUrl(item.courseOutlineRegistration.courseOutline.picturePath);
        }else{
          let indexStr = String(this.index);
          let classRoomPlaceholderIndex = String(indexStr).substr(indexStr.length - 1, indexStr.length) ;
          return config.baseUrl + 'static/images/classroom-placeholder-' + classRoomPlaceholderIndex + '.jpeg';
        }
      },
      getClassSection(item) {
        if (item.classSection) {
          return item.classSection.learnSpanNo;
        } else {
          return '-'
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

      .grid-view-img{
        opacity: 0.9;
      }
    }
  }
</style>
